/*
 * @Author: nathan
 * @Date: 2019-11-22 09:59:50
 * @LastEditors: 蒋时阳
 * @LastEditTime: 2026-04-17 14:23:23
 * @FilePath: /insurance-group-pc/src/router/index.js
 * @Description:
 *
 * Copyright (c) 2022 by 用户/公司名, All Rights Reserved.
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originPush = Router.prototype.push;
const originReplace = Router.prototype.replace;
Router.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        originPush.call(this, location, resolve, reject)
    } else {
        originPush.call(this, location, () => { }, () => { })
    }
}
Router.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject)
    } else {
        originReplace.call(this, location, () => { }, () => { })
    }
};

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            redirect: 'entry'
        },
        {
            path: '/entry',
            name: 'entry',
            meta: {
                title: '团险产品'
            },
            component: () => import('@/views/entry')
        },
        {
            path: '/write/:productId',
            name: 'write',
            component: () => import('@/views/write-interceptor')
        },
        {
            path: '/writeByAdmin/:productId/:uuid/:taskId',
            name: 'writeByAdmin',
            component: () => import('@/views/write-interceptor')
        },
        {
            path: '/writeByHistory/:productId/:orderSn',
            name: 'writeByHistory',
            component: () => import('@/views/write-interceptor')
        },
        {
            path: '/writeByUnfinish/:productId/:unfinishId',
            name: 'writeByUnfinish',
            component: () => import('@/views/write-interceptor')
        },
        {
            path: '/writeByOffline/:productId/:offlineDataUuid',
            name: 'writeByOffline',
            component: () => import('@/views/write-interceptor')
        },
        {
            path: '/orderConfirm/:productId',
            name: 'orderConfirm',
            component: () => import('@/views/orderConfirm')
        },
        {
            path: '/orderList',
            name: 'orderList',
            component: () => import('@/views/orderList')
        },
        {
            path: '/orderDetail/:orderSn',
            name: 'orderDetail',
            component: () => import('@/views/orderDetail')
        },
        {
            path: '/orderDetailUuid/:orderUuid',
            name: 'orderDetailUuid',
            component: () => import('@/views/orderDetail')
        },
        {
            path: '/orderDetailOffline/:offlineDataUuid',
            name: 'orderDetailOffline',
            component: () => import('@/views/orderDetail')
        },
        {
            path: '/payWait',
            name: 'payWait',
            component: () => import('@/views/payWait')
        },
        {
            path: '/unfinishList',
            name: 'unfinishList',
            component: () => import('@/views/unfinishList')
        },
        {
            path: '/information',
            name: 'information',
            component: () => import('@/views/information')
        },
        {
            path: '/initiate-preservation',
            name: 'initiate-preservation',
            component: () => import('@/views/initiate-preservation')
        },
        {
            path: '/preservation-list',
            name: 'preservation-list',
            component: () => import('@/views/preservation-list')
        },
        {
            path: '/product/:productId',
            name: 'product',
            meta: {
                title: '团险产品'
            },
            component: () => import('@/views/group_product_detail_3')
        },
        {
            path: '/history-quote',
            name: 'history-quote',
            component: () => import('@/views/history-quote')
        },
        {
            path: '/quotationShow',
            name: 'quotationShow',
            component: () => import('@/views/quotation-show/index.vue')
        },
        {
            path: '/quotation-page/:productId',
            name: 'quotation-page',
            component: () => import('@/views/quotation-page/quote-interceptor.vue')
        },
        {
            path: '/supplement-info/:salesGroupPolicyId',
            name: 'supplement-info',
            component: () => import('@/views/supplement-info/index.vue')
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js